import MarketingLayout from '../components/MarketingLayout';
import SEO from '../components/SEO';
import HeroSection from '../components/home/HeroSection';
import FeaturesSection from '../components/home/FeaturesSection';
import HowItWorksSection from '../components/home/HowItWorksSection';
import BenefitsSection from '../components/home/BenefitsSection';
import AuditReadyBanner from '../components/home/AuditReadyBanner';
import PricingSection from '../components/home/PricingSection';
import SecuritySection from '../components/home/SecuritySection';
import FinalCtaSection from '../components/home/FinalCtaSection';

export default function HomePage() {
  return (
    <MarketingLayout>
      <SEO
        path="/"
        keywords="public access file, PAF management, H1B compliance, DOL public access file, H-1B public access file requirements, LCA public access file, immigration compliance software, H1B document management, public access file H1B1, E3 visa compliance"
      />
      <HeroSection />
      <FeaturesSection />
      <HowItWorksSection />
      <BenefitsSection />
      <AuditReadyBanner />
      <PricingSection />
      <SecuritySection />
      <FinalCtaSection />
    </MarketingLayout>
  );
}
